import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// page
import MainPage from "../MainPage";

// api
import { getUser } from "../../services/api/user";

function FromApp() {
    const navigate = useNavigate();

    const executeGLMP = async () => {
        try{
            let userInfo = await getUser();
            if (userInfo.status === 200) {
                let href =
                process.env.REACT_APP_LAUNCHER_URL_PREFIX +
                ".metaverse://token=" +
                localStorage.getItem("token");
                window.location.href = href;
            } else {
                localStorage.removeItem("token");
                localStorage.removeItem("name");
                navigate("/sign-in");
                alert("Your login has expired. Please sign in again");
            }
        }catch(err){
            console.error(err);
            localStorage.removeItem('token');
            localStorage.removeItem('name');
            navigate('/sign-in');
        }        
    }

    useEffect(()=>{
        const token = localStorage.getItem("token");

        if(token){
            navigate('/mypage');
            executeGLMP();
        }else{
            navigate('/sign-in')
        }
    },[])

    return <MainPage />;
}

export default FromApp;